export function formatPrice(price: string): string {
  const data = price.replaceAll(",", "");

  const validRegex = /^[0-9]+$/;

  if (!validRegex.test(data)) {
    return "";
  } else {
    const priceStr = data.toString().split("");

    let formattedPrice = "";

    for (let i = priceStr.length - 1, count = 0; i >= 0; i--) {
      formattedPrice = priceStr[i] + formattedPrice;
      count++;
      if (count === 3 && i !== 0) {
        formattedPrice = "," + formattedPrice;
        count = 0;
      }
    }

    return formattedPrice;
  }
}

export function formatCart(cart: string): string {
  const data = cart.replaceAll("-", "");

  const validRegex = /^[0-9]+$/;

  if (!validRegex.test(data)) {
    return "";
  } else {
    const cartStr = data.toString().split("");

    let formattedCart = "";

    for (let i = cartStr.length - 1, count = 0; i >= 0; i--) {
      formattedCart = cartStr[i] + formattedCart;
      count++;
      if (count === 4 && i !== 0) {
        formattedCart = "-" + formattedCart;
        count = 0;
      }
    }

    return formattedCart;
  }
}

export function formatSheba(cart: string): string {
  const validRegex = /^[0-9]+$/;

  const data = cart.replaceAll("IR", "");

  if (!validRegex.test(data)) {
    return "";
  } else {
    return "IR" + data;
  }
}
